import BaseApi from './BaseApi';

class AppVersionApi extends BaseApi {
  protected getSpecificApiPrefix(): string {
    return 'managers/app-versions';
  }
}

export default AppVersionApi;
